import { NoTaxResidencyReasonCode } from '@/types/api/tax-info';

export const MAX_FOREIGN_NON_TAX_RESIDENCIES = 2;
export const FOREIGN_NON_TAX_RESIDENCY_REASON_OTHER_MAX_LENGTH = 80;

export const NO_TAX_RESIDENCY_REASON_CODES = [
  NoTaxResidencyReasonCode.TEMPORARY_LIVING,
  NoTaxResidencyReasonCode.TEMPORARY_WORK,
  NoTaxResidencyReasonCode.STUDYING_OR_TRAINING,
  NoTaxResidencyReasonCode.REMOTE_WORK_NO_LOCAL_PRESENCE,
  NoTaxResidencyReasonCode.INSUFFICIENT_DAYS,
  NoTaxResidencyReasonCode.LEGAL_TAX_EXEMPTION,
] as const;
